import React, { useEffect } from 'react';
import './Regulation.css';

const Regulation = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Regulation</h1>
        <p className="subtitle">Trade with confidence. BGI Assets is regulated by leading financial authorities.</p>

        <div className="section">
          <h2>Regulatory Information</h2>
          <p>BGI Assets is the trading name of Raw Trading Ltd, which is regulated by the Seychelles Financial Services Authority (FSA) with Securities Dealer's license number SD018.</p>
        </div>

        <div className="section">
          <h2>Client Fund Protection</h2>
          <ul className="protection-list">
            <li>Client funds held in segregated accounts with top-tier banks</li>
            <li>Negative balance protection on all retail accounts</li>
            <li>Regular audits by independent auditors</li>
            <li>Compliance with anti-money laundering regulations</li>
          </ul>
        </div>

        <div className="section">
          <h2>Regulatory Compliance</h2>
          <p>We adhere to strict regulatory standards including:</p>
          <ul className="compliance-list">
            <li>Know Your Customer (KYC) procedures</li>
            <li>Anti-Money Laundering (AML) policies</li>
            <li>Data protection and privacy regulations</li>
            <li>Fair trading practices</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Regulation;